import { platform } from '../../config';

export function useStatusBarHeight() {
  return platform === 'ios' ? '16px' : 'env(safe-area-inset-top)';
}
